// src/components/Header.js
import React from "react";
import Nav from "./Nav";
import playDEIImg from "../play_DEI.png";

const Header = () => (
  <div style={styles.wrapper}>
    <header style={styles.header}>
      <div style={styles.logo}>
        <img style={styles.img} src={playDEIImg} alt="Logo" />
      </div>
      <Nav />
    </header>
  </div>
);

const styles = {
  wrapper: {
    padding: "1.5rem",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "90rem",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "white",
    borderBottom: "1px solid #15C4C0",
  },
  logo: {
    padding: "20px",
  },
  img: {
    width: "90px",
    height: "65px",
  },
  title: {
    fontSize: "2.5rem",
    margin: "0",
  },
  subtitle: {
    fontSize: "2rem",
    margin: "10px 0",
  },
  tagline: {
    fontSize: "1.2rem",
    fontStyle: "italic",
  },
};

export default Header;
